import { createSlice } from '@reduxjs/toolkit';

const futureShiftsSlice = createSlice({
  name: 'futureShifts',
  initialState: {
    shifts: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchFutureShiftsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchFutureShiftsSuccess: (state, action) => {
      state.shifts = action.payload;
      state.loading = false;
    },
    fetchFutureShiftsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchFutureShiftsStart, fetchFutureShiftsSuccess, fetchFutureShiftsFailure } = futureShiftsSlice.actions;

export default futureShiftsSlice.reducer;
